import React, { useEffect, useState } from 'react';
import { supabaseClient } from '../utils/supabaseClient';
import { getProofUrl } from '../utils/paymentProof';

// Renders ALL proof images for a payment: the primary payments.proof_path plus any
// payment_proofs child images (Stage 31 — split-payment receipts). Fetches the child
// paths itself (RLS-scoped to viewers) and resolves each to a short-lived signed URL.
// A single-image payment renders exactly one thumbnail — byte-identical to before.
const ProofThumbnails = ({ paymentId, primaryPath, className = '' }) => {
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      const paths = [];
      if (primaryPath) paths.push(primaryPath);
      if (paymentId != null) {
        const { data } = await supabaseClient
          .from('payment_proofs').select('path')
          .eq('payment_id', paymentId).order('uploaded_at', { ascending: true });
        (data || []).forEach((r) => { if (r.path && !paths.includes(r.path)) paths.push(r.path); });
      }
      const resolved = await Promise.all(paths.map(async (p) => ({ path: p, url: await getProofUrl(p) })));
      if (active) setUrls(resolved.filter((x) => x.url));
    })();
    return () => { active = false; };
  }, [paymentId, primaryPath]);

  if (!urls.length) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {urls.map(({ path, url }) => (
        <a key={path} href={url} target="_blank" rel="noopener noreferrer" title="Open receipt">
          <img src={url} alt="Payment receipt" className="w-16 h-16 object-cover rounded border border-neutral-300" />
        </a>
      ))}
    </div>
  );
};

export default ProofThumbnails;
